/* tslint:disable */
/* eslint-disable */
export enum DfmFileStatusEnum {
  Received = 'Received',
  Processing = 'Processing',
  Processed = 'Processed',
  Failed = 'Failed',
  Omitted = 'Omitted'
}
